import * as React from 'react';

import * as S from './style';

const UploadedFilesList = ({ files }) => {
  return files.map((file) => (
    <S.Caption key={file.handle}>
      <S.SuccessBlip /> {file.filename} {Math.round(file.size / 1000)}kb ({file.mimetype})
    </S.Caption>
  ));
};

export default UploadedFilesList;
